module.exports = __webpack_public_path__ + "static/img/five.0a137ca6.png";